import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { fetchSupportMessages } from '../services/support';
import './Support.css';

const SupportMessages = () => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const getMessages = async () => {
      try {
        const data = await fetchSupportMessages();
        setMessages(data);
        setLoading(false);
      } catch (error) {
        setError(error.message);
        setLoading(false);
      }
    };

    getMessages();
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-[100vh]">
        <img
          src="/loading.gif"
          alt="Loading..."
          className="w-30 h-30 object-contain"
        />
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex flex-col justify-center items-center min-h-[100vh]">
        <img
          src="/empty.png"
          alt="Error occurred"
          className="w-64 h-auto object-contain mb-4"
        />
        <p className="text-red-500 font-medium">Error: {error}</p>
      </div>
    );
  }

  return (
    <div className="support-messages-container px-4 sm:px-6 py-3">
      <div className="mt-3">
        <button
          onClick={() => navigate(-1)}
          className="
            inline-flex
            items-center
            gap-2
            px-4
            py-2
            rounded-md
            bg-gray-200
            text-gray-700
            text-sm
            font-medium
            hover:bg-gray-300
            transition
          "
        >
          <ArrowLeft size={16} />
          Back
        </button>

        <h1 className="mt-2 text-xl sm:text-2xl font-semibold text-gray-800">
          Support Messages
        </h1>
      </div>

      <div className="overflow-x-auto">
        <table className="support-messages-table w-full">
          <thead>
            <tr>
              <th>First Name</th>
              <th>Last Name</th>
              <th>Email</th>
              <th>Topic</th>
              <th>Message</th>
              <th>Created At</th>
            </tr>
          </thead>
          <tbody>
            {messages.map((message) => (
              <tr key={message._id}>
                <td>{message.firstName}</td>
                <td>{message.lastName}</td>
                <td>{message.email}</td>
                <td>{message.topic}</td>
                <td>{message.message}</td>
                <td>{new Date(message.createdAt).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SupportMessages;
